/**
 * Idempotency utilities for ensuring request uniqueness
 * Reuses the same pattern as the existing ledger service
 */

/**
 * Generate a deterministic idempotency key for insurance operations
 * Uses the same pattern as ledgerService.generateIdempotencyKey()
 */
export const generateIdempotencyKey = (operation: string, ...params: string[]): string => {
  // Deterministic key for true idempotency (no timestamp)
  return `${operation}:${params.join(':')}`;
};

/**
 * Generate idempotency key for premium due operations
 */
export const generatePremiumDueIdempotencyKey = (
  clientId: string,
  costCenterId: string,
  amount: string,
  dueDate: string
): string => {
  return generateIdempotencyKey('premium-due', clientId, costCenterId, amount, dueDate);
};

/**
 * Generate idempotency key for payment received operations
 */
export const generatePaymentReceivedIdempotencyKey = (
  clientId: string,
  costCenterId: string,
  amount: string,
  externalPaymentId: string,
  provider: string
): string => {
  return generateIdempotencyKey('payment-received', clientId, costCenterId, amount, externalPaymentId, provider);
};

/**
 * Generate idempotency key for premium earning operations
 */
export const generatePremiumEarningIdempotencyKey = (
  clientId: string,
  costCenterId: string,
  amount: string,
  earningDate: string
): string => {
  return generateIdempotencyKey('premium-earning', clientId, costCenterId, amount, earningDate);
};
